function productSeriesTableScript() {
  const productSeriesTableElement = document.querySelector('.product-series-grid__content')
  const productSeriesTableWrappers = document.querySelectorAll('.product-series-grid__content-wrapper')

  console.log(productSeriesTableElement.children.length)
  
  productSeriesTableWrappers.forEach(wrapper => {
    const row = wrapper.querySelector('.product-series-grid__content-row')

    if (row.children.length > 3) {

      const scrollButtons = wrapper.querySelector('.product-series-grid__content-row-buttons')
      const scrollLeftButton = wrapper.querySelector('.scroll-button--left')
      const scrollRightButton = wrapper.querySelector('.scroll-button--right')

      scrollLeftButton.addEventListener('click', event => {
        row.scrollLeft -= 200
        updateScrollButtons()
      });

      scrollRightButton.addEventListener('click', event => {
        row.scrollLeft += 200
        updateScrollButtons()
      });

      function updateScrollButtons() {
        row.addEventListener('scroll', event => {
          
          if (row.scrollLeft > 30) {
            scrollLeftButton.classList.remove('button-disabled')
          }
          if (row.scrollLeft < 30) {
            scrollLeftButton.classList.add('button-disabled')
          }
          
          if (row.scrollLeft >= (row.scrollWidth - row.clientWidth)) {
            scrollRightButton.classList.add('button-disabled')
          } else {
            scrollRightButton.classList.remove('button-disabled')
          }
          
          
        })
      }
      updateScrollButtons()

    }

  });

}
productSeriesTableScript()